// extracted by css-extract-rspack-plugin
export default {"contentHeaderBackground":"contentHeaderBackground-Z4OCdC","content":"content-ATgCxp"};